import dayjs from "dayjs";

import IKO4973200 from "./assets/img/roof-shingles/IKO4973200.jpg";
import IKOCAMCG from "./assets/img/roof-shingles/IKOCAMCG.jpg";
import IKOCAMDB from "./assets/img/roof-shingles/IKOCAMDB.jpg";
import IKOCAMDG from "./assets/img/roof-shingles/IKOCAMDG.jpg";
import IKOCAMDN from "./assets/img/roof-shingles/IKOCAMDN.jpg";
import IKOCAMDW from "./assets/img/roof-shingles/IKOCAMDW.jpg";
import IKOCAMEC from "./assets/img/roof-shingles/IKOCAMEC.jpg";
import IKOCAMHS from "./assets/img/roof-shingles/IKOCAMHS.jpg";
import IKOCAMWW from "./assets/img/roof-shingles/IKOCAMWW.jpg";
import IKODYNAB from "./assets/img/roof-shingles/IKODYNAB.jpg";
import IKODYNBI from "./assets/img/roof-shingles/IKODYNBI.jpg";
import IKODYNBS from "./assets/img/roof-shingles/IKODYNBS.jpg";
import IKODYNCS from "./assets/img/roof-shingles/IKODYNCS.jpg";
import IKODYNDS from "./assets/img/roof-shingles/IKODYNDS.jpg";
import IKODYNEG from "./assets/img/roof-shingles/IKODYNEG.jpg";
import IKODYNFSG from "./assets/img/roof-shingles/IKODYNFSG.jpg";
import IKODYNGB from "./assets/img/roof-shingles/IKODYNGB.jpg";
import IKODYNGL from "./assets/img/roof-shingles/IKODYNGL.jpg";
import IKODYNMR from "./assets/img/roof-shingles/IKODYNMR.jpg";
import IKODYNSB from "./assets/img/roof-shingles/IKODYNSB.jpg";
import IKODYNSG from "./assets/img/roof-shingles/IKODYNSG.jpg";

import wallTexture1 from './assets/img/wall-textures/siding_map/wall-siding-type-1.jpg';
import wallTexture2 from './assets/img/wall-textures/siding_map/wall-siding-type-2.jpg';
import wallTexture3 from './assets/img/wall-textures/siding_map/wall-siding-type-3.jpg';
import wallTexture4 from './assets/img/wall-textures/siding_map/wall-siding-type-4.jpg';
import wallTexture5 from './assets/img/wall-textures/siding_map/wall-siding-type-5.jpg';
import wallTexture6 from './assets/img/wall-textures/siding_map/wall-siding-type-6.jpg';
import wallTexture7 from './assets/img/wall-textures/siding_map/wall-siding-type-7.jpg';
import wallTexture8 from './assets/img/wall-textures/siding_map/wall-siding-type-8.jpg';
import wallTexture9 from './assets/img/wall-textures/siding_map/wall-siding-type-9.jpg';
import wallTexture10 from './assets/img/wall-textures/siding_map/wall-siding-type-10.jpg';
import wallTexture11 from './assets/img/wall-textures/siding_map/wall-siding-type-11.jpg';
import wallTexture12 from './assets/img/wall-textures/siding_map/wall-siding-type-12.jpg';
import wallTexture13 from './assets/img/wall-textures/siding_map/wall-siding-type-13.jpg';
import wallTexture14 from './assets/img/wall-textures/brick-map/brick-map-type-1.png';
import wallTexture15 from './assets/img/wall-textures/brick-map/brick-map-type-2.jpg';
import wallTexture16 from './assets/img/wall-textures/brick-map/brick-map-type-3.jpg';
import wallTexture17 from './assets/img/wall-textures/brick-map/brick-map-type-4.jpg';
import wallTexture18 from './assets/img/wall-textures/brick-map/brick-map-type-5.jpg';

import imgCrown0 from './assets/img/tree-types/image-0.png';
import imgCrown1 from './assets/img/tree-types/image-1.png';
import imgCrown2 from './assets/img/tree-types/image-2.png';
import imgCrown3 from './assets/img/tree-types/image-3.png';
import imgCrown4 from './assets/img/tree-types/image-4.png';
import imgCrown5 from './assets/img/tree-types/image-5.png';
import imgCrown6 from './assets/img/tree-types/image-6.png';
import imgCrown7 from './assets/img/tree-types/image-7.png';
import imgCrown8 from './assets/img/tree-types/image-8.png';
import imgCrown9 from './assets/img/tree-types/image-9.png';
import imgCrown10 from './assets/img/tree-types/image-10.png';
import imgCrown11 from './assets/img/tree-types/image-11.png';
import imgCrown12 from './assets/img/tree-types/image-12.png';
import imgCrown13 from './assets/img/tree-types/image-13.png';
import imgCrown14 from './assets/img/tree-types/image-14.png';
import imgCrown15 from './assets/img/tree-types/image-15.png';
import imgCrown16 from './assets/img/tree-types/image-16.png';
import imgCrown17 from './assets/img/tree-types/image-17.png';
import { EquipmentItem, TreeData } from "./@types/types";
import { EquipmentType } from "./@types/enums";

export const DEFAULT_DATE_FROM = dayjs().subtract(1, 'month');

export const stageFilterOptions = [
    {
        label: '1: Appointment Set',
        value: '1: Appointment Set',
        desc: '1: Appointment Set',
    },
    {
        label: '2: Quote Preparation',
        value: '2: Quote Preparation',
        desc: '2: Quote Preparation',
    },
    {
        label: '3: Contract Preparation',
        value: '3: Contract Preparation',
        desc: '3: Contract Preparation',
    },
    {
        label: '4: Contracted',
        value: '4: Contracted',
        desc: '4: Contracted',
    },
    {
        label: '5: Engineering',
        value: '5: Engineering',
        desc: '5: Engineering',
    },
    {
        label: '6: Preliminary Application',
        value: '6: Preliminary Application',
        desc: '6: Preliminary Application',
    },
    {
        label: '7: Installation',
        value: '7: Installation',
        desc: '7: Installation',
    },
    {
        label: '8: Final AHJ Inspection',
        value: '8: Final AHJ Inspection',
        desc: '8: Final AHJ Inspection',
    },
    {
        label: '9: Final Application',
        value: '9: Final Application',
        desc: '9: Final Application',
    },
    {
        label: '10: Project Complete',
        value: '10: Project Complete',
        desc: '10: Project Complete',
    },
    {
        label: '11: Lost',
        value: '11: Lost',
        desc: '11: Lost',
    },
]

export const LAYER_OPTIONS = {
    MODEL : {
        ROOF: 'roof',
        OBSTRUCTION : 'obstruction',
        TREE : 'tree',
        SETBACK : 'setback',
        PATHWAY : 'pathway',
    },

    SYSTEM : {
        MODULES : 'modules',
        IRRADIANCE : 'irradiance',
    },

    MAPS : {
        MAP : 'maps',
        TERRAIN : 'terrain',
    },
} as const;

export const IMAGERY_OPTIONS  = {
    DEFAULT : 'nearmap',
    GOOGLE : 'google',
    NEARMAP : 'nearmap',
    MAPBOX : 'mapbox',
    CUSTOM : 'custom',
}

export const SLIDER_PROPERTIES_SETTINGS = {
    ROOF_PROPERTIES : {
        ROOF_HEIGHT : {
            INCH : {
                min : 0,
                max : 960,
                step : 1,
            },
            FOOT : {
                min : 0,
                max : 80,
                step : 0.1,
            },
            METER : {
                min : 0,
                max : 24.384,
                step : 1,
            },
        },
    },
    TREE_PROPERTIES : {
        CROWN_HEIGHT : {
            INCH: {
                min: 12,
                max: 1200,
                step: 1,
            },
            FOOT: {
                min: 1,
                max: 100,
                step: 0.1,
            },
            METER: {
                min: 0.3048,
                max: 30.48,
                step: 0.01,
            },
        },
        CROWN_DIAMETER : {
            INCH: {
                min: 12,
                max: 1200,
                step: 1,
            },
            FOOT: {
                min: 1,
                max: 100,
                step: 0.1,
            },
            METER: {
                min: 0.3048,
                max: 30.48,
                step: 0.01,
            },
        },
        HEIGHT : {
            INCH: {
                min: 12,
                max: 1800,
                step: 1,
            },
            FOOT: {
                min: 1,
                max: 150,
                step: 0.1,
            },
            METER: {
                min: 0.3048,
                max: 45.72,
                step: 0.01,
            },
        },
        TRUNK_RADIUS : {
            INCH: {
                min: 12,
                max: 60,
                step: 1,
            },
            FOOT: {
                min: 1,
                max: 5,
                step: 0.1,
            },
            METER: {
                min: 0.3048,
                max: 1.524,
                step: 0.01,
            },
        },
    },
    OBSTRUCTION_PROPERTIES : {
        CUBE_HEIGHT: {
            INCH: {
                min: 1,
                max: 600,
                step: 1,
            },
            FOOT: {
                min: 0.1,
                max: 50,
                step: 0.1,
            },
            METER: {
                min: 0.03,
                max: 15,
                step: 0.01,
            },
        },
        CUBE_WIDTH: {
            INCH: {
                min: 1,
                max: 600,
                step: 1,
            },
            FOOT: {
                min: 0.1,
                max: 50,
                step: 0.1,
            },
            METER: {
                min: 0.03,
                max: 15,
                step: 0.01,
            },
        },
        CUBE_LENGTH: {
            INCH: {
                min: 1,
                max: 600,
                step: 1,
            },
            FOOT: {
                min: 0.1,
                max: 50,
                step: 0.1,
            },
            METER: {
                min: 0.03,
                max: 15,
                step: 0.01,
            },
        },
        CIRCLE_RADIUS: {
            INCH: {
                min: 2,
                max: 120,
                step: 1,
            },
            FOOT: {
                min: 0.2,
                max: 20,
                step: 0.1,
            },
            METER: {
                min: 0.06,
                max: 3,
                step: 0.01,
            },
        },
        POLYGON_SIDES: {
            min: 3,
            max: 8,
            step: 1,
        },
    },
    GROUND_MOUNT_PROPERTIES : {
        ROOF_HEIGHT: {
            min: 0,
            max: 80,
            step: 0.1,
        },
        AZIMUTH: {
            min: 0,
            max: 360,
            step: 1,
        },
        PITCH: {
            min: 0,
            max: 45,
            step: 1,
        },
        SCALE: {
            X: {
                min: 15,
                step: 1,
            },
            Y: {
                min: 15,
                step: 1,
            },
        }
    },
};

export const inch2m = 0.0254, m2ft = 3.28084, ft2m = 0.3048;
export const inch4 = 4 * inch2m, inch6 = 6 * inch2m;


export const defaults = {
    ROOF_FACE_COLOR: "#ffffff",
    ROOF_EDGE_COLOR: "#000000",
    OBSTRUCTION_COLOR: "#CCCCCC",
    WALL_COLOR: "#CCCCCC",
}


function GetRoundNum(val: number, num: number) {
    if (!num) num = 0;
    return Math.round(val * Math.pow(10, num)) / Math.pow(10, num);
}

const roundS = 4;

export const moduleInfo = {
    gap: GetRoundNum(inch4, roundS),
    snapDis: GetRoundNum(inch6, roundS),
    space: GetRoundNum(1 * inch2m, roundS),
};

export const moduleSpacingInfoForBallastedRacking = {
    gap: GetRoundNum(inch4, roundS),
    snapDis: GetRoundNum(inch6, roundS),
    space: GetRoundNum(0.5 * inch2m, roundS),
};


export const BALLASTED_MODULE_RACKING_ANGLE = 9.8;

export const vendorLossesValues = {
    oneDRAW: [
        {lossName: "Name Plate", percentage: '0'},
        {lossName: "Mismatch", percentage: '0'},
        {lossName: "Connections", percentage: '0.5'},
        {lossName: "Light-Induced Degradation", percentage: '1.5'},
        {lossName: "Wiring", percentage: '2'},
        {lossName: "Soiling", percentage: '.58-.76'},
        {lossName: "Availability", percentage: '3'},
        {lossName: "Shading", percentage: 'Varies.'},
        {lossName: "Age", percentage: '0'},
        {lossName: "Snow", percentage: 'Calculation'},
        {lossName: "Other", percentage: '0'},
    ],
    GoodLeap: [
        {lossName: "Name Plate", percentage: '1'},
        {lossName: "Mismatch", percentage: '1.5'},
        {lossName: "Connections", percentage: '0.5'},
        {lossName: "Light-Induced Degradation", percentage: '1.5'},
        {lossName: "Wiring", percentage: '2'},
        {lossName: "Soiling", percentage: '2'},
        {lossName: "Availability", percentage: '2'},
        {lossName: "Shading", percentage: 'Calculation'},
        {lossName: "Age", percentage: '0'},
        {lossName: "Snow", percentage: 'Calculation'},
        {lossName: "Other", percentage: '0'},
    ],
    GoodLeapAnalysisCase2: [
        {lossName: "Name Plate", percentage: '0'},
        {lossName: "Mismatch", percentage: '0'},
        {lossName: "Connections", percentage: '0.5'},
        {lossName: "Light-Induced Degradation", percentage: '1.5'},
        {lossName: "Wiring", percentage: '2'},
        {lossName: "Soiling", percentage: '2'},
        {lossName: "Availability", percentage: '3'},
        {lossName: "Shading", percentage: 'Calculation'},
        {lossName: "Age", percentage: '0'},
        {lossName: "Snow", percentage: 'Calculation'},
        {lossName: "Other", percentage: '0'},
    ],
    GoodLeapAnalysisCase3: [
        {lossName: "Name Plate", percentage: '0'},
        {lossName: "Mismatch", percentage: '0'},
        {lossName: "Connections", percentage: '0.5'},
        {lossName: "Light-Induced Degradation", percentage: '1.5'},
        {lossName: "Wiring", percentage: '2'},
        {lossName: "Soiling", percentage: '2'},
        {lossName: "Availability", percentage: '2'},
        {lossName: "Shading", percentage: 'Calculation'},
        {lossName: "Age", percentage: '0'},
        {lossName: "Snow", percentage: 'Calculation'},
        {lossName: "Other", percentage: '0'},
    ],
};

export type VendorKey = keyof typeof vendorLossesValues;

export const lossesColumns = [
    {
        title: 'Losses',
        dataIndex: 'lossName',
        key: 'lossName',
        width: 150
    },
    {
        title: '%',
        dataIndex: 'percentage',
        key: 'percentage',
        width: 80
    }
];

export const roofTextureList = [
    { id: 1, img: IKO4973200, alt: "Sentinel Slate", name: "IKO4973200" },
    { id: 2, img: IKODYNSG, alt: "Summit Grey", name: "IKODYNSG" },
    { id: 3, img: IKOCAMCG, alt: "Charcoal Grey", name: "IKOCAMCG" },
    { id: 4, img: IKOCAMDB, alt: "Dual Black", name: "IKOCAMDB" },
    { id: 5, img: IKOCAMDG, alt: "Dual Grey", name: "IKOCAMDG" },
    { id: 6, img: IKOCAMDN, alt: "Dual Brown", name: "IKOCAMDN" },
    { id: 7, img: IKOCAMDW, alt: "Driftwood", name: "IKOCAMDW" },
    { id: 8, img: IKOCAMEC, alt: "Earthtone Cedar", name: "IKOCAMEC"},
    { id: 9, img: IKOCAMHS, alt: "Harvard Slate", name: "IKOCAMHS" },
    { id: 10, img: IKOCAMWW, alt: "Weatherwood", name: "IKOCAMWW" },
    { id: 11, img: IKODYNAB, alt: "Atlantic Blue", name: "IKODYNAB" },
    { id: 12, img: IKODYNBI, alt: "Biscayne", name: "IKODYNBI" },
    { id: 13, img: IKODYNBS, alt: "Brownstone", name: "IKODYNBS" },
    { id: 14, img: IKODYNCS, alt: "Cornerstone", name: "IKODYNCS" },
    { id: 15, img: IKODYNDS, alt: "Driftshake", name: "IKODYNDS" },
    { id: 16, img: IKODYNEG, alt: "Emerald Green", name: "IKODYNEG" },
    { id: 17, img: IKODYNFSG, alt: "Frostone Grey", name: "IKODYNFSG" },
    { id: 18, img: IKODYNGB, alt: "Granite Black", name: "IKODYNGB" },
    { id: 19, img: IKODYNGL, alt: "Glacier", name: "IKODYNGL" },
    { id: 20, img: IKODYNMR, alt: "Monaco Red", name: "IKODYNMR" },
    { id: 21, img: IKODYNSB, alt: "Shadow Brown", name: "IKODYNSB" }
];

export const wallData = [
    { id: 1, img: wallTexture1, alt: 'Wall Siding Image' },
    { id: 2, img: wallTexture2, alt: 'Wall Siding Image' },
    { id: 3, img: wallTexture3, alt: 'Wall Siding Image' },
    { id: 4, img: wallTexture4, alt: 'Wall Siding Image' },
    { id: 5, img: wallTexture5, alt: 'Wall Siding Image' },
    { id: 6, img: wallTexture6, alt: 'Wall Siding Image' },
    { id: 7, img: wallTexture7, alt: 'Wall Siding Image' },
    { id: 8, img: wallTexture8, alt: 'Wall Siding Image' },
    { id: 9, img: wallTexture9, alt: 'Wall Siding Image' },
    { id: 10, img: wallTexture10, alt: 'Wall Siding Image' },
    { id: 11, img: wallTexture11, alt: 'Wall Siding Image' },
    { id: 12, img: wallTexture12, alt: 'Wall Siding Image' },
    { id: 13, img: wallTexture13, alt: 'Wall Siding Image' },
    { id: 14, img: wallTexture14, alt: 'Wall Siding Image' },
    { id: 15, img: wallTexture15, alt: 'Wall Siding Image' },
    { id: 16, img: wallTexture16, alt: 'Wall Siding Image' },
    { id: 17, img: wallTexture17, alt: 'Wall Siding Image' },
    { id: 18, img: wallTexture18, alt: 'Wall Siding Image' }
];

export const treeList: TreeData[] = [
    { id: 1, img: imgCrown0, alt: "Pitch Pine", cM: 'crown8', tH: 70, cR: 30, cH: 30, tR: 3 },
    { id: 2, img: imgCrown1, alt: "Honey Locust", cM: 'crown7', tH: 50, cR: 40, cH: 30, tR: 9 },
    { id: 3, img: imgCrown2, alt: "Black Ash", cM: 'crown7', tH: 50, cR: 30, cH: 30, tR: 4 },
    { id: 4, img: imgCrown3, alt: "Cucumber Tree", cM: 'crown15', tH: 60, cR: 30, cH: 40, tR: 4 },
    { id: 5, img: imgCrown4, alt: "Eastern Red Cedar", cM: 'crown16', tH: 60, cR: 25, cH: 50, tR: 3 },
    { id: 6, img: imgCrown5, alt: "Black Oak", cM: 'crown11', tH: 35, cR: 40, cH: 28, tR: 3 },
    { id: 7, img: imgCrown6, alt: "Basswood", cM: 'crown1', tH: 50, cR: 33, cH: 38, tR: 2.5 },
    { id: 8, img: imgCrown7, alt: "Tulip Tree", cM: 'crown2', tH: 50, cR: 20, cH: 40, tR: 2.5 },
    { id: 9, img: imgCrown8, alt: "American Hornbeam", cM: 'crown2', tH: 50, cR: 30, cH: 40, tR: 3 },
    { id: 10, img: imgCrown9, alt: "Balsam Fir", cM: 'crown8', tH: 50, cR: 30, cH: 40, tR: 3 },
    { id: 11, img: imgCrown10, alt: "Arborvitae", cM: 'crown8', tH: 50, cR: 30, cH: 40, tR: 3 },
    { id: 12, img: imgCrown11, alt: "American Chestnut", cM: 'crown3', tH: 50, cR: 30, cH: 40, tR: 3 },
    { id: 13, img: imgCrown12, alt: "Sassafras", cM: 'crown1', tH: 50, cR: 36, cH: 36, tR: 3.5 },
    { id: 14, img: imgCrown13, alt: "Black Willow", cM: 'crown16', tH: 50, cR: 40, cH: 40, tR: 5 },
    { id: 15, img: imgCrown14, alt: "American Beech", cM: 'crown15', tH: 50, cR: 38, cH: 38, tR: 3.5 },
    { id: 16, img: imgCrown15, alt: "Bigtooth Aspen", cM: 'crown11', tH: 45, cR: 38, cH: 30, tR: 3.5 }
];

export const crownImgArr = [
    {key: 'crown0', img: imgCrown0},
    {key: 'crown1', img: imgCrown1},
    {key: 'crown2', img: imgCrown2},
    {key: 'crown3', img: imgCrown3},
    {key: 'crown4', img: imgCrown4},
    {key: 'crown5', img: imgCrown5},
    {key: 'crown6', img: imgCrown6},
    {key: 'crown7', img: imgCrown7},
    {key: 'crown8', img: imgCrown8},
    {key: 'crown9', img: imgCrown9},
    {key: 'crown10', img: imgCrown10},
    {key: 'crown11', img: imgCrown11},
    {key: 'crown12', img: imgCrown12},
    {key: 'crown13', img: imgCrown13},
    {key: 'crown14', img: imgCrown14},
    {key: 'crown15', img: imgCrown15},
    {key: 'crown16', img: imgCrown16},
    {key: 'crown17', img: imgCrown17},
];

export const monthlyEstimateMonths = [
    { short: 'Jan', long: 'January' },
    { short: 'Feb', long: 'February' },
    { short: 'Mar', long: 'March' },
    { short: 'Apr', long: 'April' },
    { short: 'May', long: 'May' },
    { short: 'Jun', long: 'June' },
    { short: 'Jul', long: 'July' },
    { short: 'Aug', long: 'August' },
    { short: 'Sep', long: 'September' },
    { short: 'Oct', long: 'October' },
    { short: 'Nov', long: 'November' },
    { short: 'Dec', long: 'December' },
] as const;

export type MonthName = typeof monthlyEstimateMonths[number]["long"];

export type MonthlyProductionEntry = {
  solar_access?: number;
  actual_production?: number;
};

export type MonthlyProductionKey = keyof MonthlyProductionEntry;

export type MonthlyProductionEstimateData = {
  [key in MonthName]?: MonthlyProductionEntry;
};

export const trainingData = [
    {
        name: 'oneDRAW - Walkthrough',
        description: 'Covers the basics of oneDRAW with a quick walkthrough of the application.',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=a43994dd-83f6-45fd-bc21-8fad4e1305dc&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['Basics']
    },
    {
        name: 'PC and Laptop Module Placement',
        description: 'Covers the module menu on a PC or Laptop, and how to add, move, or remove modules.',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=d3a79d26-91e2-4d91-b24f-1f88177b4973&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['PC', 'Laptop', 'Module Placement', 'Module Information', 'Site Information']
    },
    {
        name: 'iPad Module Placement',
        description: 'Covers the module menu on an iPad or other mobile device, and how to add, move, or remove modules.',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=687bb413-d702-4c85-af0f-8ae5ccc5e23a&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['iPad', 'Module Placement', 'Module Information', 'Site Information']
    },
    {
        name: 'Finalization Button',
        description: 'Go over the process of finalizing sites and saving or loading designs.',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=b93d8577-83e0-455a-85a3-3ee0dfbf22c7&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['Finalization', 'Design & Versioning']
    },
    {
        name: 'Tree Settings and Modifications',
        description: 'Review tree settings and properties, as well as how to add, ghost, or modify trees on a site.',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=b1a23a2a-fb42-4bba-9126-a79b5b526ed6&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['Trees', 'Ghosting']
    },
    {
        name: 'Roofing and Cosmetic Changes',
        description: 'Review tree settings and properties, as well as how to add, ghost, or modify trees on a site.',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=3a984bd7-e763-4b72-9d79-d4c37fb4b6b4&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['Roofing', 'Cosmetic']
    },
    {
        name: 'Obstruction Settings',
        description: 'Review obstruction settings and properties, as well as how to add, ghost, or modify obstructions on a site.',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=65db737e-f913-46f3-adbd-593f4ef3d8be&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['Obstructions', 'Ghosting']
    },
    {
        name: 'Buildings And Roofs',
        description: 'Walkthrough of the Building and Roofs tabs',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=d0c8c20a-de77-40c0-9340-c2eccfde2c72&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['Buildings', 'Roofs', 'Finalization']
    },
    {
        name: 'Design Certification',
        description: 'Covers finalizing, saving, and certifying designs',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=6f09305e-85f9-41b5-9bb8-4a8322fb3068&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['Designs', 'Certification', 'Finalization']
    },
    {
        name: 'Engineering Documents',
        description: 'Learn how to view, complete, and/or download an Engineering Letter, a Final Engineering Affidavit, or view other engineering documents.',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=cedf81bc-5a4a-4278-b561-8749d9abbdd2&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['Engineering', 'Building', 'Roofs']
    },
    {
        name: 'EPC Tool',
        description: 'Review of the EPC tool, price calculation, and PPW freezing, as well as the tree cart feature and removing or ghosting trees.',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=f364255b-44b8-4e40-8299-1024d3aac27a&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['Price Calculation', 'Freeze PPW', 'Tree Cart', 'Ghosting']
    },
    {
        name: 'Importing New Designs',
        description: 'Learn how to import Aurora JSON or EagleView XML files, and know the difference between them.',
        link: `https://trinitysolarsys.sharepoint.com/teams/BTIntranet/_layouts/15/embed.aspx?UniqueId=efe1db05-4fe1-4133-b22a-6659c156e539&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create`,
        tags: ['Importing Files', 'Aurora JSON', 'EagleView XML']
    },
];

export const RoofInfoTableKey = [
    {short: 'R', long: 'Roof'},
    {short: 'P', long: 'Pitch'},
    {short: 'Az', long: 'Azimuth'},
    {short: 'S', long: 'Solar Access'},
    {short: 'E', long: 'Efficiency'},
    {short: 'M', long: 'Modules'},
    {short: 'AP', long: 'Actual Production'},
]

export const emptyPackingSlipRows: EquipmentItem[] = [
    { category: EquipmentType.Module, name: "Module", financePartnerEquipmentId: '' },
    { category: EquipmentType.Inverter, name: "Inverter", financePartnerEquipmentId: '' },
    { category: EquipmentType.Optimizer, name: "Optimizer", financePartnerEquipmentId: '' },
    { category: EquipmentType.RackingSystem, name: "Racking System", financePartnerEquipmentId: '' },
    { category: EquipmentType.Rail, name: "Rail", financePartnerEquipmentId: '' },
    { category: EquipmentType.Splice, name: "Splice", financePartnerEquipmentId: '' },
    { category: EquipmentType.MidClamp, name: "Mid-Clamp", financePartnerEquipmentId: '' },
    { category: EquipmentType.EndClamp, name: "End-Clamp", financePartnerEquipmentId: '' },
    { category: EquipmentType.MlpeBracket, name: "MLPE Bracket", financePartnerEquipmentId: '' },
];